import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './EvaluationLinksView.css'
import axios from 'axios';

import FooterLanding from '../../components/footerLanding/footerLanding';
import { apiUrl } from '../../utility/Connections';
import { Layout, Input, message, Typography, Card, Button } from 'antd';
import HeaderEvaluation from '../../components/headerEvaluation/headerEvaluation';
import LoadingOverlay from '../../components/loadingOverlay/loadingOverlay';
import TableUserLinks from '../../components/tableUserLinks/tableUserLinks';
import TermsConditionsAcceptance from '../../components/termsConditionsAcceptance/termsConditionsAcceptance';

const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

const EvaluationLinksView = () => {
    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [relationShipsData, setRelationshipsData] = useState(null);
    const [orgLogo, setOrgLogo] = useState(null);
    const [evaluationData, setEvaluationData] = useState(null);
    const [serviceData, setServiceData] = useState(null);
    const [loadedData, setLoadedData] = useState(false);
    const [lookupMessage, setLookupMessage] = useState("");
    const [lookupHint, setLookupHint] = useState("");

    const [dni, setDni] = useState("");

    // TyC / Global Policy state
    const [tycData, setTycData] = useState(null);
    const [tycAccepted, setTycAccepted] = useState(false);
    const [isSubmittingTyc, setIsSubmittingTyc] = useState(false);
    const [validatedDni, setValidatedDni] = useState("");
    const [linksPagination, setLinksPagination] = useState({ page: 1, pageSize: 20, total: 0 });

    const { evlid } = useParams();
    const { useremail } = useParams();

    // useEffect para cargar datos del servicio al montar el componente
    useEffect(() => {
        if (evlid) {
            getServiceByEvlId();
        }
    }, [evlid]);

    const getServiceByEvlId = () => {
        setLoadingText("Cargando información del servicio...");
        setShowLoading(true);

        axios.get(`${apiUrl}/services/get-service-by-evl-id/${evlid}/`)
            .then(response => {
                const data = response.data;
                setServiceData(data);
                setShowLoading(false);
            })
            .catch(error => {
                console.error('Error al obtener datos del servicio:', error);
                message.error("No se pudo cargar la información del servicio.");
                setShowLoading(false);
            });
    };

    const getEvaluationRelationshipsByUser = (dni, page = 1, pageSize = 20) => {
        setLoadingText("Consultando información...");
        setShowLoading(true);
        setLookupMessage("");
        setLookupHint("");
        setLoadedData(false);
        setRelationshipsData(null);
        setEvaluationData(null);

        axios.get(`${apiUrl}/evaluation-relationships/get-evaluation-relationships-by-user/${dni}/${useremail}/${evlid}/?page=${page}&page_size=${pageSize}`)
        .then(response => {
            const data = response.data.data;
            const dataEvaluation = response.data.evaluation;
            const pagination = response.data.pagination;

            if (!data || data.length === 0) {
                setOrgLogo(null);
                setLookupMessage("No se encontró ninguna relación para los datos ingresados.");
                setLookupHint("Consulte nuevamente su documento.");
                setEvaluationData(dataEvaluation);
                setShowLoading(false);
                return;
            }

            setRelationshipsData(data);
            setEvaluationData(dataEvaluation);
            setValidatedDni(dni);
            if (pagination) {
                setLinksPagination({
                    page: pagination.page,
                    pageSize: pagination.page_size,
                    total: pagination.total,
                });
            }

            // Check global policy before showing the table
            checkGlobalPolicyByDni(dni, data[0].org_id);
        }).catch(error => {
            console.error('Error al obtener relaciones:', error);
            if (error.response?.data?.error_code === 'DOCUMENT_EMAIL_MISMATCH') {
                setOrgLogo(null);
                setLookupMessage("El documento ingresado no corresponde al correo electrónico asociado a este enlace.");
                setLookupHint("Verifique su documento o utilice el enlace asociado a su correo.");
            } else if (error.response?.status === 404) {
                setOrgLogo(null);
                setLookupMessage("No se encontró ninguna relación para los datos ingresados.");
                setLookupHint("Consulte nuevamente su documento.");
            } else {
                message.error("Ocurrió un error al consultar la información.");
            }
            setShowLoading(false);
        });
    };

    const getOrganizationLogo = (orgId) => {
        if (!orgId) {
            setOrgLogo(null);
            setShowLoading(false);
            return;
        }

        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const handleSearch = () => {
        const normalizedDni = dni.trim();

        if (!normalizedDni) {
            message.error("Por favor, ingrese su número de documento");
            return;
        }

        getEvaluationRelationshipsByUser(normalizedDni, 1, linksPagination.pageSize || 20);
    };

    const handleLinksTablePageChange = (page, pageSize) => {
        const dniToUse = validatedDni || dni.trim();
        if (!dniToUse) return;
        getEvaluationRelationshipsByUser(dniToUse, page, pageSize || linksPagination.pageSize || 20);
    };

    const checkGlobalPolicyByDni = (userDni, orgId) => {
        axios.get(`${apiUrl}/terms-conditions/check-global-policy/${userDni}/`)
            .then((response) => {
                const { code, data } = response.data;
                if (code === 'SUCCESS' && data) {
                    if (data.requires_global_acceptance) {
                        setTycData(data);
                        setTycAccepted(false);
                        getOrganizationLogo(orgId);
                    } else {
                        setTycData(null);
                        setTycAccepted(true);
                        setLoadedData(true);
                        getOrganizationLogo(orgId);
                    }
                } else {
                    setTycData(null);
                    setTycAccepted(true);
                    setLoadedData(true);
                    getOrganizationLogo(orgId);
                }
            })
            .catch(() => {
                setTycData(null);
                setTycAccepted(true);
                setLoadedData(true);
                getOrganizationLogo(orgId);
            });
    };

    const handleTycAccept = () => {
        if (!tycData) return;
        setIsSubmittingTyc(true);

        axios.post(`${apiUrl}/terms-conditions/accept-global-policy/`, {
            dni: validatedDni,
            tcc_id: tycData.tcc_id,
            tcc_text_hash: tycData.tcc_text_hash,
            user_agent: navigator.userAgent,
            decision: 'ACEPTO',
        })
            .then(() => {
                setTycAccepted(true);
                setTycData(null);
                setLoadedData(true);
                setIsSubmittingTyc(false);
            })
            .catch((error) => {
                console.error('Error accepting TyC:', error);
                setIsSubmittingTyc(false);
            });
    };

    const handleTycReject = () => {
        if (!tycData) return;

        return axios.post(`${apiUrl}/terms-conditions/accept-global-policy/`, {
            dni: validatedDni,
            tcc_id: tycData.tcc_id,
            tcc_text_hash: tycData.tcc_text_hash,
            user_agent: navigator.userAgent,
            decision: 'NO_ACEPTO',
        }).catch((error) => {
            console.error('Error recording TyC rejection:', error);
        });
    };

    const handleCloseTab = () => {
        window.close();
    };

    const showTycScreen = !showLoading && tycData && !tycAccepted && relationShipsData;
    const showTable = !showLoading && loadedData && tycAccepted;
    const showDniForm = !showLoading && !loadedData && !showTycScreen;

    return <div className='evaluation-links-root'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Layout className='evaluation-links-layout'>
            <HeaderEvaluation orgLogo={orgLogo} />
            <Content className='evaluation-links-content'>
                {/* Pantalla TyC bloqueante */}
                {showTycScreen && (
                    <div className='evaluation-links-tyc-wrapper'>
                        <TermsConditionsAcceptance
                            tycData={tycData}
                            onAccept={handleTycAccept}
                            onReject={handleTycReject}
                            isSubmitting={isSubmittingTyc}
                        />
                    </div>
                )}

                {/* Tabla de evaluaciones */}
                {showTable && (
                    <TableUserLinks
                        data={relationShipsData}
                        evaluationData={evaluationData}
                        serviceData={serviceData}
                        pagination={linksPagination}
                        onPageChange={handleLinksTablePageChange}
                    />
                )}

                {/* Formulario de DNI */}
                {showDniForm && (
                        <div className='evaluation-links-card-wrapper'>
                            <Card className='evaluation-links-card'>
                                <Title level={3} className='evaluation-links-title'>
                                    {evaluationData?.evl_title
                                        ? `Bienvenido a ${evaluationData.evl_title}`
                                        : serviceData?.srv_page_title
                                        ? `Bienvenido a ${serviceData.srv_page_title}`
                                        : 'Bienvenido'}
                                </Title>
                                <Paragraph className='evaluation-links-description'>
                                    Por favor ingresa tu documento de identidad para consultar tus enlaces de evaluación.
                                </Paragraph>

                                <div className='evaluation-links-form'>
                                    <Text className='evaluation-links-label'>Número de documento</Text>
                                    <Input
                                        placeholder='Número de documento'
                                        value={dni}
                                        size='large'
                                        onChange={(e) => setDni(e.target.value)}
                                        onPressEnter={handleSearch}
                                    />
                                    <Button type='primary' size='large' onClick={handleSearch}>
                                        Consultar
                                    </Button>
                                </div>

                                {
                                    lookupMessage && (
                                        <div className='evaluation-links-error-box'>
                                            <Title level={5} className='evaluation-links-error-title'>
                                                {lookupMessage}
                                            </Title>
                                            <Text className='evaluation-links-error-text'>
                                                {lookupHint}
                                            </Text>
                                            <Button danger onClick={handleCloseTab}>
                                                Cerrar pestaña
                                            </Button>
                                        </div>
                                    )
                                }
                            </Card>
                        </div>
                )}
            </Content>
            <FooterLanding />
        </Layout>
    </div>
}

export default EvaluationLinksView;